import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    syslogSliderLabel: {
        marginRight: theme.spacing(4),
    },

    syslogSliderContainer: {
        paddingTop: theme.spacing(1),
        width: 250,
    },

    syslogSliderSelectionText: {
        marginLeft: theme.spacing(4),
    },
}));
